module.exports = {
    currencies: require("./src/currencies.json"),
    countries: require("./src/countries.json"),
    languages: require("./src/languages.json"),
    nationalities: require("./src/nationalities.json"),
    citywithcountricodes: require("./src/citywithcountricodes.json"),
    faicons: require("./src/faicons.json")
}